import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { withAuth } from "./artifactModel";

// Artifact list for one user: loads when the panel is first expanded, exposes view/download/delete.
export const useArtifacts = (userId, isExpanded) => {
  const [loading, setLoading] = useState(false);
  const [artifacts, setArtifacts] = useState([]);

  const loadArtifacts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/artifacts/${userId}`);
      setArtifacts(response.data.artifacts || []);
    } catch (error) {
      console.error("Error loading artifacts:", error);
      setArtifacts([]);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (userId && isExpanded) loadArtifacts();
  }, [userId, isExpanded, loadArtifacts]);

  const addArtifact = (artifact) => setArtifacts((prev) => [artifact, ...prev]);

  const deleteArtifact = async (artifactId) => {
    try {
      await axios.delete(`${API}/artifacts/${userId}/${artifactId}`);
      setArtifacts((prev) => prev.filter((a) => a.artifactId !== artifactId));
      toast.success("Artifact deleted");
    } catch (error) {
      toast.error("Failed to delete artifact");
    }
  };

  const viewArtifact = (artifact) => (artifact.url ? window.open(withAuth(artifact.url), "_blank") : toast.info("Preview not available"));
  const downloadArtifact = (artifact) =>
    artifact.downloadUrl ? window.open(withAuth(artifact.downloadUrl), "_blank") : toast.info("Download not available");

  return { loading, artifacts, addArtifact, deleteArtifact, viewArtifact, downloadArtifact };
};
